__turbopack_context__.v({
  "eyebrow": "PulseOmicsGraph-module__Xebo-W__eyebrow",
  "figure": "PulseOmicsGraph-module__Xebo-W__figure",
  "head": "PulseOmicsGraph-module__Xebo-W__head",
  "lead": "PulseOmicsGraph-module__Xebo-W__lead",
  "mobileNodeLabel": "PulseOmicsGraph-module__Xebo-W__mobileNodeLabel" + " " + "PulseOmicsGraph-module__Xebo-W__nodeLabel",
  "nodeLabel": "PulseOmicsGraph-module__Xebo-W__nodeLabel",
  "plot": "PulseOmicsGraph-module__Xebo-W__plot",
  "plotMobile": "PulseOmicsGraph-module__Xebo-W__plotMobile",
  "section": "PulseOmicsGraph-module__Xebo-W__section",
  "title": "PulseOmicsGraph-module__Xebo-W__title",
});
